import React ,{useState} from "react";
import ModuleListCard from "components/businessrules/ModuleListCard";
import CustomTextField from "components/CustomTextField";
import { useTranslation } from "react-i18next";
import CircularProgressBar from "Uitls/CircularProgressBar";
import styles from "styles/modules/CopyWithName.module.scss";

export const CopyCardSourceModule = ({
  moduleData = { items: [], type: 'source', isEdited: false, isLoading: false },
  onModuleChange,
  onSelectionChange, 
  currentStep
}) => {
  const { t } = useTranslation();
  const charLimitCopyName = 2000;

  const CheckBoxComponent = ({ item }) => {
    return (
      <div className={styles.checkboxWrapper}>
        <input
          type="checkbox"
          checked={item.isSelected}
          onChange={(e) => {
            onSelectionChange(item.id, e.target.checked);
          }}
          className={styles.inputCloneBox}
          style={{cursor:"pointer"}}
        />
      </div>
    );
  };

  if (moduleData.isLoading) {
    return <CircularProgressBar isLoading={true}/>;
  }

  if (moduleData.items.length === 0) {
    return <div className={styles.noData}>No module data available</div>;
  }

  return (
    <div className={styles.moduleContainer}>
      {moduleData && moduleData.items.map((item) => (
        <article key={item.id} className={styles.moduleItem}>
          {currentStep != 1 && (<div className={styles.moduleBoxIcon}>
            <CheckBoxComponent item={item} />
          </div>)}
          <div className={styles.cardmodule} >
            <ModuleListCard
              cardData={item}
              handleView={(id) => console.log("View clicked for id:", id)}
              isCopyWithName={true}
              draggable={false}
            />
          <CustomTextField
            label={t("module.copyModuleName")}
            normalinput={true}
            handleChange={(changedName) => onModuleChange(item.id, changedName)}
            value={item.moduleName}
            required={true}
            charLimit={currentStep === 1 ? charLimitCopyName : null}
            disabled={!item.isSelected}
          />
          </div>
        </article>
      ))}
    </div>
  );
};